import { Slot } from "./slot";
import { getChildByType } from "react-nanny";
import { cx } from "class-variance-authority";

const Content = Slot();
const Leading = Slot();
const Trailing = Slot();

const Container = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  const content = getChildByType(props.children, Content);
  const leading = getChildByType(props.children, Leading);
  const trailing = getChildByType(props.children, Trailing);

  return (
    <div className={cx(props.className, "flex")}>
      {leading ? leading : null}
      {content ? content : null}
      {trailing ? trailing : null}
    </div>
  );
};

export const ThreeColumn = {
  Content,
  Leading,
  Trailing,
  Container,
};
